<template>
    <div id="app">
        <div v-if="hideWrapper">
            <div class="container-fluid extended">
                <div class="row extended" id="content-body">
                    <div v-bind:class="{ 'hidden': !finished, 'col-12': true, 'extended': true}">
                        <router-view @childInitialized="childInitialized"></router-view>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container-fluid">
                <div class="row" id="logo-bar">
                    <div class="col-12">
                        <div id="logo" @click="logoClick" class="pointer">
                            <img :src="this.skin.logo" :alt="`Logo van ${skin.region}`">
                        </div>
                    </div>
                </div>
                <div class="row" id="banner" :style="`background-image: url('${this.skin.header}');`">
                    <div class="col-12">
                        &nbsp;
                    </div>
                </div>
                <div class="row" id="title-banner">
                    <div class="col-12 text-center">
                        <h1>
                            {{title}}
                        </h1>
                    </div>
                </div>
            </div>
            <div class="container">
                <div v-if="skin.readspeaker.active" class="row">
                  <div class="col-12">
                    <div id="readspeaker">
                      <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve">
                        <a rel="nofollow" class="rsbtn_play" accesskey="L" title="Laat de tekst voorlezen met ReadSpeaker webReader" :href="`//app-eu.readspeaker.com/cgi-bin/rsent?customerid=${skin.readspeaker.code}&amp;lang=nl_nl&amp;readid=inner`">
                          <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span>Lees voor</span></span></span>
                          <span class="rsbtn_right rsimg rsplay rspart"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!--<navbar :key="navKey"></navbar>-->
                <div class="row" id="content-body">
                    <div v-bind:class="{ 'hidden': !finished, 'col-12': true}">
                        <router-view @childInitialized="childInitialized"></router-view>
                    </div>
                </div>
            </div>
            <div class="container-fluid d-none d-lg-block" id="footer">
                <div class="row">
                    <div class="col-12 text-center">
                        <h2>
                            Heeft u een vraag?
                        </h2>
                    </div>
                </div>
                <div class="row">
                    <br/>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-3 offset-lg-3 text-left footer-info-block">
                        <ul class="list-unstyled">
                            <li>
                                <a href="../faq">
                                    <i class="fa  fax fa-question"></i> <span>Kijk in de kennisbank</span>
                                </a>
                            </li>
                            <li>
                                <a :href="`mailto:${skin.contactmail}`">
                                    <i class="fa  fax fa-envelope"></i> <span>Stuur ons een e-mail</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-lg-3 offset-lg-1 text-left footer-info-block">
                        <ul class="list-unstyled">
                            <li>
                                <a :href="`tel:${skin.contactphone}`">
                                    <i class="fa  fax fa-phone"></i> <span>Bel gerust</span>
                                </a>
                            </li>
                            <!--<li>
                                <i class="fa  fax fa-newspaper"></i> <span>Ik wil een nieuwsbrief ontvangen</span>
                            </li>-->
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <hr/>
                </div>
                <div class="row flex-footer">
                    <div class="col-12 col-lg-3">
                        <h2>Andere diensten?</h2>
                        <ul class="list-unstyled">
                            <li>
                                <a href="https://ruilmijnwoning.nl" target="_blank">
                                    Woningruil
                                </a>
                            </li>
                            <!--<li>
                                Urgentie
                            </li>
                            <li>
                                Doorstromers
                            </li>-->
                        </ul>
                    </div>
                    <div class="col-12 col-lg-3" v-if="skin.app === true">
                        <h2>Download de App</h2>
                        <ul class="list-unstyled list-inline appstore">
                            <li class="list-inline-item text-center">
                                <a href="https://play.google.com/store/apps/details?id=nl.woonmatch.app.twa" target="_blank">
                                    <i class="fab fax fa-android"></i>
                                    <p>
                                        Android
                                    </p>
                                </a>
                            </li>
                            <li class="list-inline-item text-center">
                                <a href="https://apps.apple.com/nl/app/woonmatch-app/id1521635724" target="_blank">
                                    <i class="fab fax fa-apple"></i>
                                    <p>
                                        Apple
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-lg-3">
                        <h2>Over ons</h2>
                        <ul class="list-unstyled">
                            <li>
                                <a href="../pagina/contact">
                                    <span v-if="skin.plural">
                                        De corporaties
                                    </span>
                                    <span v-else>
                                        {{skin.region}}
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a href="../pagina/contact">
                                    Contact
                                </a>
                            </li>
                            <li>
                                <a href="../pagina/informatie">
                                    Informatie
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-lg-3">
                        <h2>{{skin.region}}</h2>
                        <p>
                            {{skin.infotext}}
                        </p>
                    </div>
                </div>
            </div>

            <div class="container-fluid d-block d-lg-none" id="footer-mobile">
                <div class="row">
                    <div class="col-12 text-center">
                        <h2>
                            Heeft u een vraag aan ons?
                        </h2>
                    </div>
                </div>
                <div class="row">
                    <br/>
                </div>
                <div class="row">
                    <div class="col-12 text-left footer-info-block">
                        <ul class="list-unstyled">
                            <li>
                                <i class="fa  fax fa-question"></i>
                                <a href="../faq">
                                    <span>Staat het antwoord in de kennisbank?</span>
                                </a>
                            </li>
                            <li>
                                <i class="fad fax fa-envelope"></i>
                                <a :href="`mailto:${skin.contactmail}`">
                                    <span>Stuur ons een e-mail</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="list-unstyled">
                            <li>
                                <i class="fad fax fa-phone"></i>
                                <a :href="`tel:${skin.contactphone}`">
                                    <span>Neem gerust contact met ons op</span>
                                </a>
                            </li>
                            <!--<li>
                                <i class="fad fax fa-newspaper"></i> <span>Ik wil de nieuwsbrief</span>
                            </li>-->
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <hr/>
                </div>
                <div class="row" v-if="skin.app === true">
                    <div class="col-12 text-center">
                        <h2>Download de App</h2>
                        <ul class="list-unstyled list-inline appstore">
                            <li class="list-inline-item text-center">
                                <i class="fab fax fa-android"></i>
                                <p>
                                    Android
                                </p>
                            </li>
                            <li class="list-inline-item text-center">
                                <i class="fab fax fa-apple"></i>
                                <p>
                                    Apple
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Navbar from "./components/Navbar";
  export default {
    name: 'app',
    components: {Navbar},
    data: () => {
      return {
        navKey: 0,
        finished: false,
        hideWrapper: false,
        title: 'Bezig met laden...',
        skin: {
            logo: process.env.VUE_APP_LOGO,
            header: process.env.VUE_APP_HEADER,
            region: process.env.VUE_APP_REGION,
            plural: process.env.VUE_APP_PLURAL === 'true',
            infotext: process.env.VUE_APP_INFOTEXT,
            contactmail: process.env.VUE_APP_CONTACTMAIL,
            contactphone: process.env.VUE_APP_CONTACTPHONE,
            readspeaker: {
              active: process.env.VUE_APP_READSPEAKER === undefined ? false : true,
              code: process.env.VUE_APP_READSPEAKER
            },
            app: process.env.VUE_APP_HASMOBILE
          }
      }
    },
    watch:{
      $route (){
        // clear alert on location change
        this.navKey++;
      }
    },
    methods: {
      childInitialized(data) {
        this.title = data.title
        this.finished = true
      },
      logoClick() {
          if(this.$store.state.registration.newUser === undefined || this.$store.state.registration.newUser === false) {
            window.location.href = '../woningaanbod'
          }
      }
    },
    mounted() {
        this.hideWrapper = this.$route.meta.hideWrapper || false
      console.log(this.skin.app);
    }
  }
</script>

<style scoped>
    .extended {
        margin: 0px;
        padding: 0px;
    }
    @media (max-width: 576px) {
      #banner {
        max-height: 70px;
      }
      #title-banner {
        max-height: 50px;
      }
      #title-banner h1 {
        line-height: 50px;
        font-size: 23px;
      }
    }
    .flex-footer {
      display: flex;
      justify-content: center;
    }

</style>
